/*
 * @Author: cc
 * @LastEditTime: 2021-06-21 22:17:07
 */
/*
 * @Author: cc
 * @LastEditTime: 2021-04-19 15:15:36
 */
import { useEffect, useState } from "react";
export function useGetRandomCode<T>(str: T) {
  const [randomImgUrl, setRandomImgUrl] = useState<string>("");
  function getRandomImgFn() {
    fetch(`/main/ran/random`)
      .then(
        (response) => response.blob(),
        (error) => console.log("An error occurred.", error)
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        setRandomImgUrl(url);
      });
  }
  useEffect(() => {
    getRandomImgFn();
  }, []);
  return [randomImgUrl, getRandomImgFn as any];
}
